module.exports = __webpack_public_path__ + "img/ape-mint-banner.c3116b9a.png";